import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  postAPI_Create_Question_Option,
  putAPI_Update_Question_Option,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Validation from '../../../../../../components/Validation';
import TagsForm from './TagsForm';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';
function QuestionOptionForm({
  /** Globle property id from redux */
  propertyId,
  QuestionId,
  CancelQuestionOption,
  loadResponse,
  optionName,
  Id,
  updateOption,
  childQuestionshow,
  messagesList,
  optionData,
  setType,
  quesionSetsList,
  formList,
  roomTags,
  productTags,
  elem,
}) {
  const [fields, setFields] = useState([
    {
      key: 'Add Own Field',
      label: 'Add Own Field',
      value: 'Add Own Field',
    },
  ]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldModel, setFieldModel] = useState(false);
  const [field, setField] = useState(['']);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [buttonTextInput, setButtonTextInput] = useState(
    optionName == undefined ? '' : optionName
  );
  const [childMessage, setChildMessage] = useState(
    optionData == undefined ? null : optionData.childQuestionId
  );
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    PropertyId: propertyId === '-1' ? null : propertyId,
    QuestionId: QuestionId,
    Option: '',
    DisplayOrder: optionData === undefined ? 1 : optionData.displayOrder,
    ChildQuestionId: null,
    Status: 'Active',
    Creator: 'API',
    displayMessage:
      optionData === undefined ? false : optionData.displayMessage,
    actionType: optionData === undefined ? 'None' : optionData.actionType,
    actionValues: optionData === undefined ? '' : optionData.actionValues,
    categoryTags: optionData === undefined ? null : optionData.categoryTags,
    fields:
      optionData !== undefined &&
        optionData.fields !== undefined &&
        optionData.fields.length > 0
        ? optionData.fields
        : [],
  });

  useEffect(() => {
    setPostData({
      ...postData,
      Option: buttonTextInput,
      ChildQuestionId: childMessage,
    });
  }, [buttonTextInput]);

  useEffect(() => {
    if (
      optionData !== undefined &&
      optionData.fields !== undefined &&
      optionData.fields.length > 0
    ) {
      let lst = [];
      optionData.fields.map((m) => lst.push({ label: m, value: m, key: m }));
      setSelectedFields(lst.filter((f) => f.value !== 'Add Own Field'));
      lst.push({
        key: 'Add Own Field',
        label: 'Add Own Field',
        value: 'Add Own Field',
      });
      setFields(lst);
    }
  }, [optionData]);

  const handleFieldChange = (e, index) => {
    let lst = [...field];
    lst[index] = e.target.value;
    setField(lst);
  };

  const handleAddField = () => {
    let lst = [...field];
    lst.push({
      from: '',
      to: '',
    });
    setFields(lst);
  };

  const handleChecked = (e) => {
    setPostData({ ...postData, displayMessage: e.target.checked });
  };
  const handleRemoveField = (index) => {
    let lst = [...field];
    lst = lst.filter((f, i) => i !== index);
    setFields(lst);
  };

  const handleCaptionChange = (e) => {
    setButtonTextInput(e.target.value);
  };

  const handleMessageChange = (e) => {
    setChildMessage(e.target.value);
  };

  const handleChangeAction = (e) => {
    setPostData({ ...postData, actionType: e.target.value });
  };
  const handleChangeActionValue = (e) => {
    setPostData({ ...postData, actionValues: e.target.value });
  };

  const handleChangeTags = (data) => {
    var categorytag =
      optionData.categoryTags === null
        ? { roomTags: [], productTags: [] }
        : optionData.categoryTags;
    if (data.isRoom !== true) {
      categorytag.productTags = data.tags;
    } else {
      categorytag.roomTags = data.tags;
    }
    setPostData({ ...postData, categoryTags: categorytag });
  };
  const handleSave = async () => {
    if (Id === undefined) {
      try {
        return await AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_Question_Option}`,
          data: postData,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              CancelQuestionOption();
              loadResponse();
            }, 1000);
          }
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      let data = {
        Option: buttonTextInput,
        ActionType: postData.actionType,
        ActionValues: postData.actionValues,
        CategoryTags: postData.categoryTags,
        Status: 'Active',
        Updater: 'Dashboard',
        DisplayOrder: postData.DisplayOrder,
        ChildQuestionId: childMessage,
        fields: postData.fields,
        displayMessage: postData.displayMessage,
      };
      try {
        return await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Question_Option}/${Id}`,
          data: data,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              updateOption(buttonTextInput, childMessage);
            }, 1000);
          }
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChangeField = (selectedTags) => {
    let fie = [...selectedFields];
    if (
      selectedTags.filter((elem) => elem.value === 'Add Own Field').length === 0
    ) {
      setSelectedFields(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setPostData({
        ...postData,
        fields: tagsArr,
      });
    } else {
      setFieldModel(!fieldModel);
    }
  };

  const handleCancel = () => {
    CancelQuestionOption();
    // if (setIsEditingToFalse) {
    //   setIsEditingToFalse();
    // }
    // if (setIsAddImageToFalse) {
    //   setIsAddImageToFalse();
    // }
    // toggleButtonAddedd();
    // toggleButtonMessageAddedd();
  };
  const handleField = (val) => {
    let tag = [...fields];
    tag.push({ label: field[0], value: field[0], key: field[0] });

    let tag1 = [...selectedFields];
    tag1.push({ label: field[0], value: field[0], key: field[0] });

    setFields(tag);
    setSelectedFields(tag1);
    setFieldModel(!fieldModel);
    setField(['']);
    const tagsArr = tag1.map((elem) => elem.value);
    setPostData({
      ...postData,
      fields: tagsArr,
    });
  };
  return (
    <div>
      <Row>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}

        <Colxx xxs="12" className="mb-3">
          <Input
            type="text"
            value={buttonTextInput}
            onChange={handleCaptionChange}
          ></Input>
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
          <Input
            type="select"
            value={postData.DisplayOrder}
            name="displayOrder"
            onChange={(e) =>
              setPostData({ ...postData, DisplayOrder: e.target.value })
            }
          >
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </Input>
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          <Input
            type="select"
            value={postData.actionType}
            name="actionType"
            onChange={handleChangeAction}
          >
            <option value="">Select Action...</option>
            <option value="NewQuestionSet">
              Go to a different Question Series
            </option>
            <option value="NewQuestion">Go to next question</option>
            <option value="OpenForm">Open Form</option>
            <option value="OpenRoom">Show Rooms</option>
            <option value="OpenProduct">Show Products</option>
            <option value="OpenHumanChat">Human Chat</option>
          </Input>
        </Colxx>
        {postData.actionType === 'NewQuestionSet' && (
          <Colxx xxs="12" className="mb-3">
            <Input
              type="select"
              value={postData.actionValues}
              name="actionValues"
              onChange={handleChangeActionValue}
            >
              <option value="">Select Question Series…</option>
              {quesionSetsList.length > 0 &&
                quesionSetsList.map((i) => (
                  <option value={i.id}>{i.name}</option>
                ))}
            </Input>
          </Colxx>
        )}
        {postData.actionType === 'NewQuestion' && (
          <Colxx xxs="12" className="mb-3">
            <Input
              type="select"
              value={childMessage}
              name="type"
              onChange={handleMessageChange}
            >
              <option value="">Select Question…</option>
              {messagesList.length > 0 &&
                messagesList.map((i) => (
                  <option value={i.id}>{i.message}</option>
                ))}
            </Input>
          </Colxx>
        )}
        {elem?.response !== undefined &&
          elem?.response?.details &&
          elem?.response?.details.apiCollection &&
          elem?.response?.details?.apiCollection.length > 0 && (
            <Colxx xxs="12" className="mb-3">
              <CustomInput
                type="checkbox"
                value={postData.displayMessage}
                onChange={handleChecked}
                defaultChecked={postData.displayMessage}
              >
                Display Message
              </CustomInput>
            </Colxx>
          )}
        {postData.actionType === 'OpenForm' && (
          <Colxx xxs="12" className="mb-3">
            <Input
              type="select"
              value={postData.actionValues}
              name="actionValues"
              onChange={handleChangeActionValue}
            >
              <option value="">Select Forms...</option>
              {formList.length > 0 &&
                formList.map((i) => <option value={i.id}>{i.name}</option>)}
            </Input>
          </Colxx>
        )}
        {postData.actionType === 'OpenRoom' && (
          <Colxx xxs="12" className="mb-3">
            <TagsForm
              roomTags={roomTags}
              isRoom={true}
              optionData={optionData}
              handleChangeTags={handleChangeTags}
            ></TagsForm>
          </Colxx>
        )}
        {postData.actionType === 'OpenProduct' && (
          <Colxx xxs="12" className="mb-3">
            <TagsForm
              productTags={productTags}
              optionData={optionData}
              handleChangeTags={handleChangeTags}
            ></TagsForm>
          </Colxx>
        )}
        {postData.actionType === 'OpenForm' && (
          <Colxx xxs="12" className="mb-3">
            <Select
              isMulti={true}
              className="react-select"
              classNamePrefix="react-select"
              name="languageCode"
              value={selectedFields}
              placeholder="Select Field"
              onChange={(e) => handleChangeField(e)}
              options={fields}
            />
          </Colxx>
        )}
      </Row>
      <Row>
        <Colxx xxs="12">
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >
            <Button
              color="secondary"
              className="add-button"
              size="xs"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Colxx>
      </Row>
      <Modal
        isOpen={fieldModel}
        toggle={() => {
          setFieldModel(!fieldModel);
        }}
      >
        <ModalHeader toggle={() => setFieldModel(!fieldModel)}>
          ADD OWN FIELD
        </ModalHeader>
        <ModalBody>
          {field.length > 0 &&
            field.map((m, index) => (
              <Fragment>
                <div className="mb-2">
                  <Input
                    type="text"
                    name="from"
                    placeholder="QueryString"
                    value={m}
                    onChange={(e) => handleFieldChange(e, index)}
                  />
                </div>
              </Fragment>
            ))}
          {/* 
          <Button color="primary" outline onClick={() => handleAddField()}>
            + Add
          </Button> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleField()}>
            Add
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setFieldModel(!fieldModel);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps)(QuestionOptionForm));
